var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',[_c('label',[_vm._v("得分")]),_c('div',[_vm._v(_vm._s(_vm.info.score_my)+" / "+_vm._s(_vm.info.score_total))])]),_c('div',[_c('label',[_vm._v("正确率")]),_c('div',[_vm._v(_vm._s(_vm.info.score_rate)+"%")])]),_c('div',[_c('label',[_vm._v("解析")]),_c('div',[_vm._v(_vm._s(_vm.detail.gre_parse))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }